<template>
    <section class="flex-column">
        <!-- HEADER -->
        <header>
            <h1 class="m-0 mb-6 fs-32 regular">
                {{ $l10n.__('Choisissez votre nouveau plan Sellsy') }}
            </h1>
        </header>
        <!-- PLAN CARDS -->
        <div class="plans-card flex-row mt-6 pb-6 font-patron">
            <div
                v-for="(card, cardKey) in plansData"
                :key="cardKey"
                class="plans-card-data flex-column secondary-blue fs-4 ai-center"
                :class="[
                    card.code === currentPlan ? 'isPlanActual' : '',
                    !renewOnOlderPricingVersion && card.code === previousCurrentPlan
                        ? 'isPlanPrevious'
                        : '',
                ]"
            >
                <!-- CARD CONTENT -->
                <div class="plans-card-data-content acenter flex-column white-bkg p-4 pt-5 pb-5">
                    <!-- TITLE -->
                    <template
                        v-if="
                            card.code === currentPlan ||
                            (!renewOnOlderPricingVersion && card.code === previousCurrentPlan)
                        "
                    >
                        <p class="m-0 primary plan-card-data-content-actual bold fs-2">
                            {{ $l10n.__('plan actuel') | upperCase }}
                        </p>
                        <Underline class="underline-svg mb-1" />
                    </template>
                    <h1 class="semibold mt-0 mb-5">{{ card.title }}</h1>

                    <!-- PRICE -->
                    <span class="btn secondary-grey-bkg btn-small black">{{
                        $l10n.__('À partir de')
                    }}</span>
                    <h2 class="mt-1 mb-0 bold">
                        <span>{{
                            getPriceAmountByMonth(card.code)
                                | floatNumber
                                | numberformatWithOptions({ precision: 0 }, true)
                        }}</span>
                        <small class="fs-3 bold">
                            {{ $l10n.__('/utilisateur') }}
                        </small>
                    </h2>

                    <!-- LIMITS -->
                    <ul class="">
                        <li
                            v-for="(limit, limitKey) in card.limits"
                            :key="limitKey"
                            class="fs-3 flex-row mt-4 pb-4"
                        >
                            <span>{{ limitLabel[limitKey].value }}</span>
                            <span class="bold">{{ limit.value }}</span>
                        </li>
                    </ul>

                    <!-- Contact commercials -->
                    <CompassButton
                        :label="$t.__('common.actions.contact_sales')"
                        type="primary-contrast"
                        size="large"
                        onclick="MySupport.getForm()"
                        v-if="!canBeSelected(card)"
                    />

                    <!-- Go the next tab -->
                    <CompassButton
                        :label="planLabelButton(card.code)"
                        type="primary"
                        size="large"
                        @click="submitSelectedPlan(card.code)"
                        v-else
                    />
                </div>
            </div>
        </div>
        <questions />
    </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import FormMixin from 'mixins/FormMixins';
import Questions from '../Questions.vue';
import Underline from 'logged/pricing/underline.svg';

const renewCart = createNamespacedHelpers('renewCart');

export default {
    components: {
        Questions,
        Underline,
    },
    mixins: [FormMixin],
    computed: {
        ...renewCart.mapGetters([
            'previousCurrentPlanLabel',
            'previousCurrentPlan',
            'currentPlan',
            'getPricesPlans',
            'getLocalStorage',
            'isSourceSale',
            'numformat',
            'plan',
            'plans',
            'plansData',
            'productsWithLicences',
            'recurrency',
            'computeLoading',
            'renewOnOlderPricingVersion',
        ]),
    },
    methods: {
        ...renewCart.mapActions(['updatePlan']),
        planLabelButton(plan) {
            if (plan === this.currentPlan) return this.$l10n.__('Conserver ce plan');
            return this.$l10n.__('Sélectionner ce plan');
        },
        /**
         * Define if plan is selectable or not
         * Return boolean (true : is selectalbe)
         */
        canBeSelected(card) {
            return this.currentPlan === card.code;
        },

        /**
         * Check if it's yearly plan offer, if yes, return the price for a month
         */
        getPriceAmountByMonth(plan) {
            let selectedPlan = this.getPricesPlans.find(
                (license) => license.code === this.whichPlan(plan),
            );
            return this.recurrency === 'YEARLY' ? selectedPlan?.price / 12 : selectedPlan?.price;
        },

        /**
         * Return current card plan's code
         */
        whichPlan(plan) {
            return plan + '_' + this.recurrency;
        },

        /**
         * Use action in pricingV4 to update plan and products prices
         * then use nextAction() from ClientCart
         */
        submitSelectedPlan(plan) {
            this.updatePlan(plan);
            this.$trigger('PlanCart:submitSelectedPlan', null);
        },
    },

    data() {
        return {
            limitLabel: [
                { id: 'profiles', value: window.i18n.__('Profils privilèges') },
                { id: 'customfields', value: window.i18n.__('Champs personnalisés') },
                { id: 'pipelines', value: window.i18n.__('Pipelines') },
                { id: 'dunning', value: window.i18n.__('Plans de relances automatiques') },
                { id: 'support', value: window.i18n.__('Support') },
                { id: 'esign', value: window.i18n.__('Crédit Signature électronique') },
                { id: 'email', value: window.i18n.__('Crédit Email') },
                { id: 'sms', value: window.i18n.__('Crédit SMS') },
                { id: 'mail', value: window.i18n.__('Crédit courrier') },
                { id: 'api', value: window.i18n.__('API') },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.plans-card {
    justify-content: space-between;
    place-items: end;
    padding: 0;
    grid-gap: 26px;

    .plans-card-data {
        flex: 1;

        //for deskto screen
        @media only screen and (min-width: 1200px) {
            min-width: 300px;
        }
        .plans-card-data-content {
            z-index: 1;
            width: 100%;
            border: solid 1px white;
            border-radius: 16px;

            .plan-card-data-content-actual {
                width: fit-content;
                align-self: center;
            }

            .underline-svg {
                align-self: center;
            }

            h2 {
                align-items: baseline;
                display: flex;
                font-size: 40px;
                justify-content: center;
            }
            h1 + .btn {
                border-color: $secondary-grey;
                width: fit-content;
                align-self: center;
                border-radius: 16px;
            }
            ul {
                display: grid;
                & > li {
                    justify-content: space-between;
                    span {
                        text-align: right;
                    }
                    span:not(.bold) {
                        text-align: left;
                    }
                    &:not(:last-child) {
                        border-bottom: 1px $gray-40 solid;
                    }
                }
            }
            .btn-plan {
                padding: 8px 24px;
                font-size: 17px;
                transition: background-color 0.1s ease;
                line-height: inherit;
                height: auto;
            }
        }
    }
}
.isPlanActual {
    .plans-card-data-content {
        border: solid 2px $secondary-blue !important;
    }
}
</style>
